function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".markera{fill:#3b3b3b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-593.319 -8553.459)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(593.319 8553.459)"
}, /*#__PURE__*/React.createElement("path", {
  className: "markera",
  d: "M598.564,8567.657h0a.921.921,0,0,1-.742-.368c-.1-.136-.21-.285-.335-.452-1.353-1.821-4.169-5.61-4.169-8.173a5.245,5.245,0,0,1,10.49,0c0,2.639-2.822,6.388-4.178,8.19l-.322.43A.922.922,0,0,1,598.564,8567.657Zm0-13.185a4.216,4.216,0,0,0-4.231,4.191c0,2.228,2.781,5.97,3.969,7.567l.263.354.256-.342c1.189-1.58,3.974-5.28,3.974-7.58A4.216,4.216,0,0,0,598.564,8554.473Z",
  transform: "translate(-593.319 -8553.459)"
})), /*#__PURE__*/React.createElement("path", {
  className: "markera",
  d: "M615.236,8573.961a.84.84,0,1,1-.84.84.841.841,0,0,1,.84-.84m0-1.014a1.854,1.854,0,1,0,1.854,1.854,1.856,1.856,0,0,0-1.854-1.854Z",
  transform: "translate(-16.672 -16.194)"
}));

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.49,
    height: 14.198,
    viewBox: "0 0 10.49 14.198",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.b5bdbef0.svg";
export { ForwardRef as ReactComponent };